import Animate from './Animate';
import Chart from './Chart';
import Item from './Item';
import FeatureList from './FeatureList';
import Footer from './Footer';
import Logo from './Logo';
import ValueProp from './ValueProp';

export {
  Animate,
  Chart,
  Item,
  Logo,
  FeatureList,
  Footer,
  ValueProp,
}



// WEBPACK FOOTER //
// ./src/components/index.js